// eslint-disable-next-line no-unused-vars
import { PerformanceChartStatsState } from '../types';
import '../../types';

/**
 * @param {PerformanceChartStatsState} draft - Draft state.
 * @param {object} payload - Action payload.
 */
export const setPerformanceChartSeasonsStats = (
    draft,
    {
        seasonId,
        roundStats
        
    }
) => {
    draft.data.season = {
        ...draft.data.season,
        [ seasonId ]: [
            ...roundStats,
        ]
    };
};